import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import ads from "../../../assets/qrcode/advertisement-ads.jpeg";
import sebslogo from "../../../assets/sebs/sebs.png";
import "./AllThemeFooter.css";

const AllThemeFooter = ({ apiResponse }) => {
  // const [adLoaded, setAdLoaded] = React.useState(false);
  // useEffect(() => {
  //   console.log('trying to load ads', apiResponse);
  //   console.log('adLoaded: ', adLoaded, (!apiResponse || apiResponse.organization.isPaid));
  //   // Initialize ads
  //   try {
  //     if (adLoaded) return;
  //     if (!apiResponse || apiResponse.organization.isPaid) return;
  //     // console.log('loading ads ');
  //     // (window.adsbygoogle = window.adsbygoogle || []).push({});
  //     setAdLoaded(true);
  //   } catch (e) {
  //     console.error("AdSense error:", e);
  //   }
  // }, [apiResponse]);

  // useEffect(() => {
  //   if (apiResponse && !apiResponse.organization.isPaid && window.adsbygoogle) {
  //     window.adsbygoogle.push({});
  //   }
  // }, [apiResponse]);

  return (
    <div className="pt-2 m-0 footerBlock">
      {apiResponse && !apiResponse.organization.isPaid && (
        <>
          <Row className="d-flex justify-content-center m-0">
            <Col lg={6} sm={8} xs={12} className="mb-2">
            <div className="ad-fallback">
                <img
                  src={ads}
                  alt="Advertisement"
                  className=" h-25 w-25"
                />
              </div>
                          {/* <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-4036596239405267"// // Replace with your AdSense publisher ID
                data-ad-slot="1090252249"// // Replace with your Ad slot ID
                data-ad-format="auto"
                data-full-width-responsive="true"
              ></ins> */}

            </Col>
          </Row>
          <Row className="mb-4 p-0 mx-0 mt-2">
            <Col md={12} className="mx-0">
              <p className="responsive-p">
                Create a similar website at <span className="Zero">ZERO</span> cost. Create it yourself as you like !!
              </p>
              <Link to="/register">
                <Button
                  color="warning"
                  size="sm"
                  style={{ fontWeight: "bold" }}
                >
                  Get Started Now
                </Button>
              </Link>
            </Col>
          </Row>
        </>
      )}
      <Row className="p-0 mx-0">
        <Col className="mt-3">
          <h6
            style={{
              fontStyle: "italic",
              color: "#c0c0c0",
            }}
            className="powered"
          >
            Powered by <img src={sebslogo} className="logo" alt="SEBS Logo" />
          </h6>
        </Col>
      </Row>
    </div>
  );
};

export default AllThemeFooter;